import application from 'application/application';

// import template from './keywords-list.template.html';

import controller from './keywords-list.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.movements.keywordsList', {
				url: '/palavras-chave?paginaAtual&palavraChave&diario&caderno',
				views: {
					'movements@root.default.movements': {
						// templateUrl: template,
						controller
					}
				}
			});

	}]);
